import { FLAT_PAGE, FLOOR_PAGE, ROUTES, SECTION_PAGE } from "./routes";
import createHistory from 'history/createBrowserHistory'
import { housingNav } from "./components"
import $ from "jquery";

class App {
    constructor(containerSelector) {
        this.history = createHistory();
        this.history.listen((location, action) => {
            if (action === "POP" && location.state) {
                const {page, params} = location.state;

                this.go(page, params);
            }
        });

        this.containerSelector = containerSelector;
        $(() => {
            housingNav.init();
        })
    }

    getContainer() {
        if (!this.$container) {
            this.$container = $(this.containerSelector);
        }

        return this.$container;
    }

    go(routeName, params) {
        $(() => {
            const viewConstructor = ROUTES[routeName];
            const $container = this.getContainer();

            if ($container.length) {
                const view = new viewConstructor($container, params, this);
                view.render();
            }

        });
    }

    init() {
        const $container = this.getContainer();
        if ($container.length) {
            const {pageRoute, pageParams, paths, apiPaths} = $container.data('params');
            this.paths = paths;
            this.apiPaths = apiPaths;
            this.saveCurrentState(pageRoute, pageParams);
            this.go(pageRoute, pageParams);
        }
    }

    makePath(routeName, urlValues) {
        let path = this.paths[routeName];
        for (let key in urlValues) {
            const value = urlValues[key];
            path = path.replace("#" + key + "#", value)
        }

        return path
    }

    pushState(routeName, urlValues, routeParams, withoutRender) {
        let path = this.makePath(routeName, urlValues);

        this.history.push(path, {
            page: routeName,
            params: routeParams
        });

        if (!withoutRender) {
            this.go(routeName, routeParams);
        }
    }

    replaceState(routeName, urlValues, routeParams) {
        let path = this.makePath(routeName, urlValues);

        this.history.replace(path, {
            page: routeName,
            params: routeParams,
        })
    }

    saveCurrentState(routeName, routeParams) {
        this.history.replace(window.location.pathname + window.location.search, {
            page: routeName,
            params: routeParams
        })
    }

    handleFlatClick(e) {
        e.preventDefault();
        const $link = $(e.target).closest('.js-get-flat');

        let housingCode = $link.data('housing-code'),
            section = $link.data('section'),
            floor = $link.data('floor'),
            flat = $link.data('id');

        if ($link.is('.disabled')) {
            return;
        }

        this.app.pushState('FLAT_PAGE', {
            HOUSING_CODE: housingCode,
            SECTION_ID: section,
            FLOOR_ID: floor,
            APARTMENT_ID: flat
        }, {
            id: parseInt(flat)
        })
    }

    handleSectionFlatClick(e) {
        e.preventDefault();
        const $link = $(e.target).closest('.js-get-flat');

        let housingCode = $link.data('housing-code'),
            housingId = $link.data('housing-id'),
            section = $link.data('section'),
            floor = $link.data('floor'),
            flat = $link.data('id');

        if ($link.is('.disabled')) {
            return;
        }

        this.app.pushState('FLOOR_SELECTED_FLAT_PAGE', {
            HOUSING_CODE: housingCode,
            SECTION_ID: section,
            FLOOR_ID: floor,
            APARTMENT_ID: flat,
            ID: flat
        }, {
            housingId: parseInt(housingId),
            id: parseInt(floor),
            selectedFlat: parseInt(flat)
        })
    }

    handleFloorClick(e) {
        e.preventDefault();
        const $link = $(e.target).closest('.js-get-floor');

        if ($link.is('.disabled')) {
            return;
        }

        let housingId = $link.data('housing-id'),
            housingCode = $link.data('housing-code'),
            section = $link.data('section'),
            floor = $link.data('floor');

        this.app.pushState('FLOOR_PAGE', {
            HOUSING_CODE: housingCode,
            SECTION_ID: section,
            FLOOR_ID: floor
        }, {
            housingId: parseInt(housingId),
            id: parseInt(floor)
        })
    }

    handleSectionClick(e) {
        e.preventDefault();

        let $link = $(e.target),
            housingId = $link.data('housing-id'),
            housingCode = $link.data('housing-code'),
            section = $link.data('section'),
            floor = $link.data('similar-floor');

        if ($link.is('.current')) {
            return;
        }

        if (!floor) {
            this.app.pushState('SECTION_PAGE', {
                HOUSING_CODE: housingCode,
                SECTION_ID: parseInt(section)
            }, {
                housingId: parseInt(housingId),
                id: parseInt(section)
            })
        } else {
            this.app.pushState('FLOOR_PAGE', {
                HOUSING_CODE: housingCode,
                SECTION_ID: section,
                FLOOR_ID: floor
            }, {
                housingId: parseInt(housingId),
                id: parseInt(floor)
            })
        }

    }

    handleRightColExpand(e) {
        e.preventDefault();
        const $target = $('.block-section-full');
        const sectionWidth = $target.find('.section').width();
        $target.find('.section').width(sectionWidth);

        if ($target.is('.closed')) {
            $target.removeClass('closed');
            localStorage.setItem('floorFull', 0);
        } else {
            $target.addClass('closed');
            localStorage.setItem('floorFull', 1);
        }
    }

    initScroll() {
        $('.js-scrolling').mCustomScrollbar({
            axis: 'y',
            scrollInertia: 500,
            scrollbarPosition: 'inside',
            theme: "minimal-dark",
            mouseWheel: {
                enable: true,
                scrollAmount: 200
            }
        });
    }

    svgLight(el) {
        const box = '.image-area',
            hoverItem = '.hover',
            lightItem = '.section',
            currentClass = 'current',
            disabledClass = 'disabled';

        return $(el).each(function () {
            $(document)
                .on('mouseenter', hoverItem, function (e) {
                    e.preventDefault();

                    const $this = $(this),
                        $parentBox = $this.parents(box),
                        $lightArea = $parentBox.find(lightItem);

                    if ($this.is('.' + disabledClass)) return;

                    const id = $this.data('id');

                    $lightArea.each(function () {
                        if ($(this).data('id') === id) {
                            $(this).addClass(currentClass);
                        }
                    });
                })
                .on('mouseleave', hoverItem, function (e) {
                    e.preventDefault();

                    const $this = $(this),
                        $parentBox = $this.parents(box),
                        $lightArea = $parentBox.find(lightItem);

                    if ($this.is('.' + disabledClass)) return;

                    $lightArea.removeClass(currentClass);
                })
            ;
        });
    }
}

window.App = App;


// WEBPACK FOOTER //
// ./js/app.js